import styles from './HelpIcon.module.scss';

import React from 'react';

export default (props) => (
  <div {...props} className={props.className} styleName='help-icon' />
);



// WEBPACK FOOTER //
// ./src/components/HelpIcon.js